import { POSITIONAL } from '@quantiply/common/constants';
import {
  FETCH_ALGO_BY_ID_REQUEST,
  FETCH_ALGO_BY_ID_SUCCESS,
  FETCH_ALGO_BY_ID_FAILURE,
  EMIT,
  ALGO_EDIT_CONFIG_SETTINGS_TOGGLE_CLIENT_ID_SHOW,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_CANCEL,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_ON,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE,
  ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_START,
  ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_STOP,
  ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_START,
  ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_STOP,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_START,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_STOP,
  ALGO_EDIT_UPDATE_CREATE_LEG_DATA,
  ALGO_EDIT_UPDATE_CONFIG_DATA,
  ALGO_EDIT_CREATE_LEG,
  ALGO_EDIT_UPDATE_CONFIG_LEG_DATA,
  ALGO_EDIT_OPEN_POSITION_TABLE_MODAL,
  ALGO_EDIT_CLOSE_POSITION_TABLE_MODAL,
  ALGO_EDIT_DELETE_CONFIG_LEG,
  ALGO_EDIT_DUPLICATE_CONFIG_LEG,
  ALGO_EDIT_PAGE_LOADED_TRUE,
  ALGO_EDIT_PAGE_LOADED_FALSE,
  ALGO_EDIT_UPDATE_PROFIT_LOCK_TRAILING_SL,
  ALGO_EDIT_SAVE_STOP,
  ALGO_EDIT_SAVE_START,
  ALGO_EDIT_VALIDATION_FAILURE,
  ALGO_EDIT_VALIDATION_CLEAR,
  ALGO_EDIT_PRE_SAVE_CONFIG_FIX,
  ALGO_STATUS_UPDATE,
  NOTIFICATION_ADD_ENTRY,
  ALGO_EDIT_CONFIGURATION_DECORATOR,
  ALGO_EDIT_CHANGE_NAME,
  ALGO_EDIT_CONFIG_SAVE_EABLED,
  ALGO_EDIT_CONFIG_SAVE_DISABLED,
  ALGO_EDIT_CONFIG_CREATE_MODAL_OPEN,
  ALGO_EDIT_CONFIG_CREATE_MODAL_CLOSE,
  ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS,
  ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS_DONE,
  ALGO_EDIT_CONFIG_RESET,
  ALGO_EDIT_DUPLICAT_CONFIG_LEG_LOADING,
  ALGO_EDIT_CREATE_ALGO_REQUEST,
  ALGO_EDIT_CREATE_ALGO_SUCCESS,
  ALGO_EDIT_CREATE_ALGO_ERROR,
  ALGO_EDIT_JOURNEY_SELECT_UPDATE,
  ALGO_EDIT_LEG_MULTI_SELECT,
  ALGO_EDIT_BULK_EDIT_LEG_PREMIUM_INPUT_INCREMENT,
} from '../../constants/ActionTypes';
import { algos, setAuthorizationHeader } from '../../api';
import storage from '../../storage';
import {
  getIsAlgoEditConfigFetching,
  getAlgoId,
  getAlgoEditConfigConfigurations,
  getConfirmationsPositionalMIS,
  getAlgoEditConfig,
  getAlgoMainStatus,
} from './getters';
import { errorHandler } from '../../helpers/error-handler';
import { configurationsDefault } from './defaultValues';
import { timeoutPromise } from '../../helpers/promises';
import {
  convertNormalDataToTreeData,
  convertTreeData,
} from '../../components/Tree/utils/data-converter';
import { getIsAlgosConfig } from '../../reducers';
import { uniqueId } from '../../helpers/unique-id';
import {
  futuresSelectOptions,
  optionsSelectOptions,
} from '../../partials/AlgoConfig/PositionsTable/LegInstrumentToggle/Contracts';
import { getIsLiveData, getLivePositionsState } from '../algo-live/getters';

function addBulkEditLeg(dayUnderlyingsExpiryTags) {
  const bulkEditLeg = {
    id: `${uniqueId()}`,
    base: 'BANKNIFTY',
    segment: 'SEGMENT_OPTIONS',
    side: 'CE',
    transactionType: 'B',
    quantity: 1,
    strike: 'ATM',
    mp: false,
    product: 'I',
    expiryTag: 'CURRENT_MONTH',
    selected: false,
    isBulkEditLeg: true,
  };

  const finalContract = bulkEditLeg.side
    ? optionsSelectOptions
    : futuresSelectOptions;

  const valuesFinalContract = finalContract.map((item) => item.value);

  const baseExpiryTags = dayUnderlyingsExpiryTags[bulkEditLeg.base] || [];

  const filtredFinalContract = valuesFinalContract.filter((item) =>
    baseExpiryTags.includes(item)
  );

  const selectedExpiryTag = filtredFinalContract?.length
    ? filtredFinalContract[0]
    : '';

  bulkEditLeg.expiryTag = selectedExpiryTag;

  return bulkEditLeg;
}

function convertLegsToUiFormat(configurationsRaw) {
  const config = { ...configurationsRaw };
  const legs = config?.legs || [];

  const newLegs = [];

  for (let index = 0; index < legs.length; index++) {
    const leg = legs[index];

    const {
      // eslint-disable-next-line no-unused-vars
      jTree,
      // eslint-disable-next-line no-unused-vars
      jLegs,
      ...restProps
    } = leg;

    if (jTree) {
      newLegs.push({
        ...restProps,
        journeyTree: convertTreeData(jTree),
        isJourney: true,
      });
    } else {
      newLegs.push({
        ...restProps,
      });
    }
  }

  return newLegs;
}

function convertMatchingToUiFormat(configurationsRaw) {
  const config = { ...configurationsRaw };
  const matching = config?.matching || [];

  const newMatching = [
    {
      mode: 'NO_MATCHING',
      active: false,
    },
    {
      mode: 'MATCH_PREMIUM_WITH_MAX_DIFF',
      active: false,
      maxDiff: 1,
    },
    {
      mode: 'PREMIUM_CLOSE_TO',
      active: false,
      premiumCloseTo: 1,
    },
    {
      mode: 'PREMIUM_RANGE',
      active: false,
      lower: 1,
      upper: 1,
    },
    {
      mode: 'COMB_PREM',
      active: false,
      type: 'LT',
      val1: 1,
    },
  ];

  for (let index = 0; index < matching.length; index++) {
    const matchingItem = matching[index];

    const targetIndex = newMatching.findIndex(
      (item) => item.mode === matchingItem.mode
    );

    if (targetIndex < 0) {
      continue;
    }

    newMatching[targetIndex] = {
      ...newMatching[targetIndex],
      ...matchingItem,
    };
  }

  return newMatching;
}

export const fetchAlgoById = (id) => async (dispatch, getState) => {
  try {
    if (getIsAlgoEditConfigFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    dispatch({
      type: FETCH_ALGO_BY_ID_REQUEST,
    });

    const data = await algos.getAlgoById(id);

    const config = getIsAlgosConfig(getState());
    const underlyingsExpiryTags = config?.underlyingsExpiryTags || {};
    const algoEditConfig = getAlgoEditConfig(getState());
    const day = algoEditConfig?.day || 'ELSE';
    const dayUnderlyingsExpiryTags = underlyingsExpiryTags[day] || {};

    if (data?.data?.data?.configurations?.legs.length) {
      const legs = convertLegsToUiFormat(data.data.data.configurations);
      data.data.data.configurations.legs = [...legs];
      const bulkLegData = addBulkEditLeg(dayUnderlyingsExpiryTags);

      data.data.data.configurations.legs = [
        bulkLegData,
        ...data.data.data.configurations.legs,
      ];
    }

    if (data?.data?.data?.configurations) {
      const matching = convertMatchingToUiFormat(
        data?.data?.data?.configurations
      );

      data.data.data.configurations.matching = [...matching];
    }

    dispatch({
      type: FETCH_ALGO_BY_ID_SUCCESS,
      data,
    });

    return Promise.resolve(data);
  } catch (error) {
    dispatch({
      type: FETCH_ALGO_BY_ID_FAILURE,
      data: {
        error,
      },
    });

    return Promise.reject(error);
  }
};

export const fetchAlgoHealthStatus = (algoId) => (dispatch) => {
  dispatch({
    type: EMIT,
    payload: {
      method: 'get_health_status',
      data: {
        orderApi: true,
        liveFeed: true,
        algo: algoId,
      },
    },
  });
};

export const toggleShowClientId = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_SETTINGS_TOGGLE_CLIENT_ID_SHOW,
  });

  return Promise.resolve();
};

export const onModifyLive = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_ON,
  });

  return Promise.resolve();
};

export const onModifyCancel = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_CANCEL,
  });

  return Promise.resolve();
};

export const onModifySave = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE,
  });

  return Promise.resolve();
};

export const onModifySaveStart = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_START,
  });

  return Promise.resolve();
};

export const onModifySaveStop = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_STOP,
  });

  return Promise.resolve();
};

export const onSqOffAllStart = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_START,
  });

  return Promise.resolve();
};

export const onSqOffAllStop = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_STOP,
  });

  return Promise.resolve();
};

export const sqOffAll = () => async (dispatch, getState) => {
  try {
    const id = getAlgoId(getState());

    setAuthorizationHeader(storage.getItem('token'));
    const res = await algos.sqOffAll(id);

    return Promise.resolve(res);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const onTerminateStart = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_START,
  });

  return Promise.resolve();
};

export const onTerminateStop = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_STOP,
  });

  return Promise.resolve();
};

export const terminate = () => async (dispatch, getState) => {
  try {
    const id = getAlgoId(getState());

    setAuthorizationHeader(storage.getItem('token'));
    const res = await algos.terminate(id);

    return Promise.resolve(res);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const createLegDataUpdate = (field, value) => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_UPDATE_CREATE_LEG_DATA,
    field,
    value,
  });

  return Promise.resolve();
};

export const createLeg = () => (dispatch, getState) => {
  const config = getIsAlgosConfig(getState());
  const underlyingsExpiryTags = config?.underlyingsExpiryTags || {};
  const algoEditConfig = getAlgoEditConfig(getState());
  const day = algoEditConfig?.day || 'ELSE';
  const dayUnderlyingsExpiryTags = underlyingsExpiryTags[day] || {};

  dispatch({
    type: ALGO_EDIT_CREATE_LEG,
    dayUnderlyingsExpiryTags,
  });

  return Promise.resolve();
};

export const configurationDataUpdate = (field, value) => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_UPDATE_CONFIG_DATA,
    field,
    value,
  });

  return Promise.resolve();
};

export const configLegDataUpdate =
  (id, field, value) => (dispatch, getState) => {
    const { positions = [] } = getLivePositionsState(getState()) || {};
    const algoMainStatus = getAlgoMainStatus(getState()) || '';
    const algoRunning = getIsLiveData(getState()) || false;

    dispatch({
      type: ALGO_EDIT_UPDATE_CONFIG_LEG_DATA,
      id,
      field,
      value,
      livePositions: positions,
      algoMainStatus,
      algoRunning,
    });

    return Promise.resolve();
  };

export const journeyLegSelectUpdate =
  (legId, id, value, level, node) => (dispatch) => {
    dispatch({
      type: ALGO_EDIT_JOURNEY_SELECT_UPDATE,
      id: legId,
      details: {
        id,
        value,
        level,
        node,
      },
    });

    return Promise.resolve();
  };

export const deleteConfigLeg = (id) => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_DELETE_CONFIG_LEG,
    id,
  });

  return Promise.resolve();
};

export const dupliacteConfigLeg = (id) => async (dispatch) => {
  dispatch({
    type: ALGO_EDIT_DUPLICATE_CONFIG_LEG,
    id,
  });

  await timeoutPromise(200);

  dispatch({
    type: ALGO_EDIT_DUPLICAT_CONFIG_LEG_LOADING,
    data: false,
  });

  return Promise.resolve();
};

export const openPositionModal =
  (name, data = {}) =>
  (dispatch) => {
    dispatch({
      type: ALGO_EDIT_OPEN_POSITION_TABLE_MODAL,
      name,
      data,
    });

    return Promise.resolve();
  };

export const closePositionModal = (name) => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CLOSE_POSITION_TABLE_MODAL,
    name,
    data: {},
  });

  return Promise.resolve();
};

export const pageLoadedTrue = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_PAGE_LOADED_TRUE,
  });

  return Promise.resolve();
};

export const pageLoadedFalse = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_PAGE_LOADED_FALSE,
  });

  return Promise.resolve();
};

export const changeProfitLockAndTrailingSl = (value) => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_UPDATE_PROFIT_LOCK_TRAILING_SL,
    value,
  });

  return Promise.resolve();
};

export const algoSaveStart = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_SAVE_START,
  });

  return Promise.resolve();
};

export const algoSaveStop = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_SAVE_STOP,
  });

  return Promise.resolve();
};

export const preSaveConfigFix = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_PRE_SAVE_CONFIG_FIX,
  });

  return Promise.resolve();
};

export const clearAllAlgoEditErros = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_VALIDATION_CLEAR,
  });

  return Promise.resolve();
};

function simplifyLegs(configurationsRaw) {
  const config = { ...configurationsRaw };
  const legs = config?.legs || [];

  const newLegs = [];

  for (let index = 0; index < legs.length; index++) {
    const leg = legs[index];

    if (leg.isBulkEditLeg) {
      continue;
    }

    const {
      // eslint-disable-next-line no-unused-vars
      isJourney,
      // eslint-disable-next-line no-unused-vars
      jTree,
      // eslint-disable-next-line no-unused-vars
      journeyTree,
      // eslint-disable-next-line no-unused-vars
      jLegs,
      // eslint-disable-next-line no-unused-vars
      updatedAtJourney,
      mp,
      // eslint-disable-next-line no-unused-vars
      selected,
      ...restProps
    } = leg;

    const newLegsProps = {
      ...restProps,
    };

    if (!leg.parentId) {
      newLegsProps.mp = mp;
    }

    if (leg.isJourney) {
      const jTree = convertNormalDataToTreeData(leg.journeyTree);

      newLegs.push({
        ...newLegsProps,
        jTree,
      });
    } else {
      newLegs.push(newLegsProps);
    }
  }

  return [...newLegs];
}

export const validateAlgoSettings = () => async (dispatch, getState) => {
  dispatch({
    type: ALGO_EDIT_VALIDATION_CLEAR,
  });

  const configurations = getAlgoEditConfigConfigurations(getState());
  const legs = simplifyLegs(getAlgoEditConfigConfigurations(getState()));
  const newConfigurations = { ...configurations };

  newConfigurations.legs = [...legs];

  const { algoValidation } = await import('../../helpers/algo-validation');

  const errorsClient = algoValidation(newConfigurations);

  console.log(errorsClient, newConfigurations);

  if (Object.entries(errorsClient).length) {
    dispatch({
      type: ALGO_EDIT_VALIDATION_FAILURE,
      errors: errorsClient,
    });

    return Promise.reject(errorsClient);
  } else {
    dispatch({
      type: ALGO_EDIT_VALIDATION_CLEAR,
    });

    return Promise.resolve();
  }
};

export const checkConfirmationsAlgoSettings = () => (dispatch, getState) => {
  const configurations = getAlgoEditConfigConfigurations(getState());
  const isPositional = configurations?.tradingType === POSITIONAL;
  const legsFiltered =
    configurations && configurations.legs
      ? configurations.legs.filter((item) => !item.isBulkEditLeg)
      : [];
  const isAnyLegMis =
    legsFiltered &&
    legsFiltered.length &&
    legsFiltered.some((leg) => leg.product === 'I')
      ? true
      : false;
  const { done: isPositionalMisConfirmed = false } =
    getConfirmationsPositionalMIS(getState());

  if (isPositional && isAnyLegMis && !isPositionalMisConfirmed) {
    dispatch(showPositionalMis());
    return Promise.reject(null);
  }

  return Promise.resolve();
};

export const saveAlgo = (id) => async (dispatch, getState) => {
  try {
    setAuthorizationHeader(storage.getItem('token'));

    const configurations = getAlgoEditConfigConfigurations(getState());
    const legs = simplifyLegs(getAlgoEditConfigConfigurations(getState()));
    const newConfigurations = { ...configurations };

    newConfigurations.legs = legs;

    await algos.saveAlgoConfig(id, newConfigurations);

    return Promise.resolve();
  } catch (e) {
    const errorsProcessed = errorHandler(e);

    dispatch({
      type: ALGO_EDIT_VALIDATION_FAILURE,
      errors: errorsProcessed,
    });

    return Promise.reject(e);
  }
};

export const fetchAlgoByIdAndUpdateAlgoStatus = (id) => async (dispatch) => {
  try {
    setAuthorizationHeader(storage.getItem('token'));

    const data = await algos.getAlgoById(id);
    const { _id = null, status = 'NOT_RUNNING' } =
      data && data.data && data.data.data ? data.data.data : {};

    dispatch({
      type: ALGO_STATUS_UPDATE,
      data: {
        algo: _id.toString(),
        status,
      },
    });

    return Promise.resolve();
  } catch (error) {
    const message = errorHandler(error);

    dispatch({
      type: NOTIFICATION_ADD_ENTRY,
      data: {
        type: 'error',
        message: message,
      },
    });

    return Promise.reject(null);
  }
};

export const configurationDecorator = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIGURATION_DECORATOR,
  });

  return Promise.resolve();
};

export const createAlgoFiller = () => (dispatch, getState) => {
  const data = {
    message: 'Ok',
    status: 'success',
    data: {
      _id: 'create-new',
      code: 'OPTIONS_SPREADS_LEGS',
      name: '',
      configurations: { ...configurationsDefault },
    },
  };

  const config = getIsAlgosConfig(getState());
  const underlyingsExpiryTags = config?.underlyingsExpiryTags || {};
  const algoEditConfig = getAlgoEditConfig(getState());
  const day = algoEditConfig?.day || 'ELSE';
  const dayUnderlyingsExpiryTags = underlyingsExpiryTags[day] || {};

  const bulkLegData = addBulkEditLeg(dayUnderlyingsExpiryTags);

  data.data.configurations.legs.push(bulkLegData);

  dispatch({
    type: FETCH_ALGO_BY_ID_SUCCESS,
    data: {
      data,
    },
  });

  return Promise.resolve(data);
};

export const nameChange = (value) => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CHANGE_NAME,
    value,
  });

  return Promise.resolve();
};

export const configSaveEnabled = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_SAVE_EABLED,
  });

  return Promise.resolve();
};

export const configSaveDisabled = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_SAVE_DISABLED,
  });

  return Promise.resolve();
};

export const openCreateModal = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_CREATE_MODAL_OPEN,
  });

  return Promise.resolve();
};

export const closeCreateModal = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_CREATE_MODAL_CLOSE,
  });

  return Promise.resolve();
};

export const createAlgo =
  ({ name, code, day, broker, configSave = false, type = undefined }) =>
  async (dispatch, getState) => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      dispatch({
        type: ALGO_EDIT_CREATE_ALGO_REQUEST,
      });

      const configurations = getAlgoEditConfigConfigurations(getState());
      const legs = simplifyLegs(getAlgoEditConfigConfigurations(getState()));
      const newConfigurations = { ...configurations };

      newConfigurations.legs = legs;

      if (configSave) {
        await algos.createAlgo({
          name,
          code,
          day,
          broker,
          configurations: newConfigurations,
          type,
        });
      } else {
        await algos.createAlgo({
          name,
          code,
          day,
          broker,
          type,
        });
      }

      dispatch({
        type: ALGO_EDIT_CREATE_ALGO_SUCCESS,
      });

      return Promise.resolve();
    } catch (e) {
      const errorsProcessed = errorHandler(e);

      dispatch({
        type: ALGO_EDIT_CREATE_ALGO_ERROR,
        errors: errorsProcessed,
      });

      return Promise.reject(e);
    }
  };

export const showPositionalMis = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS,
    data: true,
  });
};

export const confirmPositionalMis = () => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS_DONE,
  });
};

export const algoConfigReset = () => async (dispatch) => {
  dispatch({
    type: ALGO_EDIT_CONFIG_RESET,
  });

  return Promise.resolve();
};

export const legMultiSelect = (selectState) => (dispatch) => {
  dispatch({
    type: ALGO_EDIT_LEG_MULTI_SELECT,
    select: selectState,
  });

  return Promise.resolve();
};

export const bulkEditLegPremiumInputIncrement =
  (field, value) => (dispatch) => {
    dispatch({
      type: ALGO_EDIT_BULK_EDIT_LEG_PREMIUM_INPUT_INCREMENT,
      field,
      value,
    });

    return Promise.resolve();
  };
